import { createAction, props } from '@ngrx/store'

export enum RootTypes {
  SET_KC_ATTRIBUTES = '[ROOT] Set KC ATTRIBUTES',

}

export const RootActions = {
  setKcAttributes: createAction(
    RootTypes.SET_KC_ATTRIBUTES,
    props<{ payload: { kcUuid: string; kcEmail: string; kcFirstName: string; kcLastName: string } }>(),
  ),
}
